import React from 'react';
import PortButton from '../PortButton';
import {
  getSwitchPortIndex,
  buildPortSlotArray,
  buildSfpSlotArray,
  gridIndexToPortNumber,
} from '../portLayout';
import { enhancedTheme } from '../utils';

const Switch48Sfp = ({
  ports,
  diagramConfig,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
}) => {
  const config = diagramConfig || {
    portCount: 48,
    sfpCount: 6,
    portRows: 2,
    sfpRows: 1,
    topRowNumbering: 'odd',
  };

  const rj45 = buildPortSlotArray(config);
  const sfp = buildSfpSlotArray(config);
  const colsPerRow = Math.ceil(config.portCount / config.portRows);
  const sfpColsPerRow = Math.ceil(config.sfpCount / config.sfpRows);

  ports.forEach((port) => {
    const slot = getSwitchPortIndex(port, config);
    if (!slot) return;
    if (slot.section === 'rj45') rj45[slot.index] = port;
    if (slot.section === 'sfp') sfp[slot.index] = port;
  });

  const registeredRj45 = ports.filter(
    (p) => getSwitchPortIndex(p, config)?.section === 'rj45',
  ).length;

  const renderPort = (port, index, section, slotNumber) => (
    <PortButton
      key={port?._id || `${section}-${index}`}
      port={port}
      slotNumber={slotNumber}
      label={`${section}-${slotNumber}`}
      selected={port && String(selectedPortId) === String(port._id)}
      connected={port && connectedPortIds.has(String(port._id))}
      registered={Boolean(port)}
      onClick={onPortClick}
      onRegisterAnchor={onRegisterAnchor}
      size={13}
    />
  );

  const topRowLabel =
    config.topRowNumbering === 'odd'
      ? 'Top row: odd port numbers'
      : 'Top row: even port numbers';

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          marginBottom: 6,
          color: enhancedTheme.sectionLabel,
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 4,
        }}
      >
        <span>
          RJ45 Ports ({config.portCount} · {config.portRows} row
          {config.portRows > 1 ? 's' : ''})
        </span>
        <span style={{ fontWeight: 400, color: '#8c8c8c' }}>
          {registeredRj45} registered · {topRowLabel}
        </span>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${colsPerRow}, 13px)`,
          gap: 3,
          padding: 8,
          background: '#fafafa',
          border: '1px solid #d9d9d9',
          borderRadius: 4,
          marginBottom: 8,
        }}
      >
        {rj45.map((port, i) =>
          renderPort(
            port,
            i,
            'rj45',
            gridIndexToPortNumber(i, config),
          ),
        )}
      </div>
      {config.sfpCount > 0 && (
        <>
          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              marginBottom: 6,
              color: enhancedTheme.sectionLabel,
            }}
          >
            SFP Slots ({config.sfpCount} · {config.sfpRows} row
            {config.sfpRows > 1 ? 's' : ''})
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${sfpColsPerRow}, 13px)`,
              gap: 3,
              padding: 8,
              background: '#fafafa',
              border: '1px solid #d9d9d9',
              borderRadius: 4,
            }}
          >
            {sfp.map((port, i) =>
              renderPort(port, i, 'sfp', config.portCount + i + 1),
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Switch48Sfp;
